import z from 'zod';

export const PickupTaskResponseSchema = z.object({
  tasks: z.array(z.string()).or(z.boolean()),
  message: z.string(),
});
